import axios from 'axios';
import { StorageKey } from '../enums/storage-key.enum';
import { OKTA_AUTH_STATUS } from '../config/webapi.config';
import { UrlAndQueryParamKey } from '../enums/url-and-query-param-key.enum';

// Add a request interceptor
axios.interceptors.request.use(
    (config) => {

        
        if (!config.url.includes('User/ValidateToken')) {
            config.headers['Authorization'] = 'ANsid ' + sessionStorage.getItem(UrlAndQueryParamKey.ANSID);
        }

        // config.headers['Content-Type'] = 'application/json';
        return config;
    },
    (error) => {
        Promise.reject(error);
    }
);
// const RequestInterceptor = axios;
export default axios;

